import { useState } from "react";
import type { Movie } from "@/mocks/movies";

interface ShareBarProps {
  movie: Movie;
}

const socials: { icon: string; label: string; template: string }[] = [
  { icon: "ri-weibo-line", label: "微博", template: "https://service.weibo.com/share/share.php?url=" },
  { icon: "ri-wechat-line", label: "微信", template: "" },
  { icon: "ri-qq-line", label: "QQ", template: "https://connect.qq.com/widget/shareqq/index.html?url=" },
  { icon: "ri-twitter-x-line", label: "X", template: "https://twitter.com/intent/tweet?url=" },
];

export default function ShareBar({ movie }: ShareBarProps) {
  const [copied, setCopied] = useState(false);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";
  const shareTitle = `${movie.title}高清电影详情与剧情介绍`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      const el = document.createElement("textarea");
      el.value = shareUrl;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  const openSocial = (template: string, label: string) => {
    if (!template) {
      copyLink();
      return;
    }
    const url = `${template}${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}`;
    window.open(url, "_blank", "noopener,noreferrer,width=640,height=520");
    void label;
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
      >
        <i className={copied ? "ri-check-line" : "ri-link"} aria-hidden="true"></i>
        {copied ? "链接已复制" : "复制链接"}
      </button>

      <div className="flex items-center gap-2">
        {socials.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={() => openSocial(item.template, item.label)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-700 cursor-pointer"
            aria-label={`分享到${item.label}`}
            title={`分享到${item.label}`}
          >
            <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
          </button>
        ))}
      </div>

      {copied && (
        <span className="animate-fade-in font-label text-xs text-accent-700">分享链接已复制到剪贴板</span>
      )}
    </div>
  );
}